<template>
  <div>
    <div class="head-bar">
      <el-button type="danger" @click="_del_do">删除本地及云</el-button>
      <el-input v-model="datas.add.id" placeholder="ID"></el-input>
    </div>
    <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
      <el-table-column prop="id" label="ID" width="100" sortable="custom"></el-table-column>
      <template v-for="(item, index) in mix_fields">
        <el-table-column :prop="item.COLUMN_NAME" :label="item.COLUMN_COMMENT" :width="item.width"
          v-if="item.is_show == 1" :key="index">
          <template slot-scope="scope">
            {{ scope.row[item.COLUMN_NAME] }}
          </template>
        </el-table-column>
      </template>
      <el-table-column label="文件">
        <template slot-scope="scope">
          <el-tooltip effect="dark" placement="left">
            <img :src="scope.row.url" alt="" style="height: 100px" />
            <div slot="content">
              <img :src="scope.row.url" style="width: 100%; max-width: 1000px; display: block" />
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="primary"
            @click="_quick_edit('file', scope.row.id, 'check_code', 10, 0)">识别错误，移除删除名单（正常图才点击）</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
        :total="datas.total">
      </el-pagination>
    </div>
    <ls-table-data :table="table" @fields="(e) => {
          mix_fields = e;
        }
        "></ls-table-data>
  </div>
</template>
<script>
export default {
  data() {
    return {
      table: "file",
      datas: {
        add: {
          append: ["user"],
          check_no: 1,
        },
      },
    };
  },
  created() {
    this._load();
  },
  methods: {
    _del_do() {
      this.$http.post("file/del_do").then((res) => {
        if (res.code) {
          this._load(1);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
